import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import General from "./General";
import Productiontable from "./Production/Productiontable";
import Dashboardstatics from "./Dashboard/Dashboardstatics";

function StatisticsDashboard() {
  const Status = useSelector(
    (state) => state.statistics.ManagementStatsToggleStatus
  );
  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Statistics Dashboard
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        <ToggleDetails />
        <div className="w-fit ml-auto flex flex-wrap border-b border-blue-200  mr-6 ">
          <input
            className="w-fit bg-transparent  p-2 placeholder-blue-200 "
            type="text"
            placeholder="Search Specific Item"
          />
          <button className=" w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.1206 13.7553L13.5772 9.87719C14.4317 8.87406 14.9369 7.64031 14.9369 6.30781C14.9369 2.95469 11.7409 0.226562 7.81186 0.226562C3.88358 0.226562 0.6875 2.95469 0.6875 6.30781C0.6875 9.66156 3.88358 12.3891 7.81186 12.3891C9.30116 12.3891 10.6843 11.9972 11.8295 11.3278L16.397 15.2266L18.1206 13.7553ZM2.77721 6.30781C2.77721 3.93781 5.03607 2.00969 7.81259 2.00969C10.5891 2.00969 12.848 3.93781 12.848 6.30781C12.848 8.67781 10.5891 10.6059 7.81259 10.6059C5.03534 10.6059 2.77721 8.67781 2.77721 6.30781Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
        </div>

        {Status === "General" ? <General /> : null}
        {Status === "Production" ? <Productiontable /> : null}
        {Status === "Warehouse" ? <Dashboardstatics /> : null}
      </div>
    </>
  );
}

export default StatisticsDashboard;
